import React from "react";
import Layout from "../pages/Layout";
//import "bootstrap/dist/css/bootstrap.min.css";
import { Helmet } from "react-helmet";

const AboutUs = () => {
    return (
        <div>
            <Helmet>
        <title>About Us - Factbazaar</title>
        <meta name="description" content="Learn more about Factbazaar, your trusted source for accurate and up-to-date news from around the world." />
  <meta name="keywords" content="Factbazaar, About Us, news platform, reliable news, journalism, breaking news" />
  <meta name="author" content="Factbazaar Team" />
      </Helmet>
           <Layout>
        <div className="container my-5">
            <div className="row">
                <div className="col-lg-12 text-center">
                    {/* <h1 className="mb-4 text-primary">About Us</h1> */}
                    <p className="lead">
                        Welcome to <strong>Factbazaar</strong>, your trusted source for the latest news, insights, and updates from around the world.
                    </p>
                </div>
            </div>

            <div className="row mt-4">
                <div className="col-md-6">
                    <img src="/img/news-825x525.jpg" className="img-fluid rounded" alt="News Reporting" />
                </div>
                <div className="col-md-6">
                    <h3 className="text-secondary">Who We Are</h3>
                    <p>
                        We are a dedicated team of journalists, editors, and news enthusiasts committed to delivering accurate and up-to-date news. 
                        Our mission is to keep you informed about global events in an unbiased and professional manner.
                    </p>
                    <h3 className="text-secondary">Our Vision</h3>
                    <p>
                        Our vision is to be the leading news platform where people can find reliable information, breaking news, and in-depth analysis on various topics.
                    </p>
                </div>
            </div>

            <div className="row mt-5">
                <div className="col-md-4 text-center">
                    <i className="fas fa-newspaper fa-3x text-primary"></i>
                    <h4 className="mt-3">Reliable News</h4>
                    <p>We provide authentic and fact-checked news from trusted sources.</p>
                </div>
                <div className="col-md-4 text-center">
                    <i className="fas fa-users fa-3x text-primary"></i>
                    <h4 className="mt-3">Our Team</h4>
                    <p>Our journalists work 24/7 to bring you the latest news.</p>
                </div>
                <div className="col-md-4 text-center">
                    <i className="fas fa-globe fa-3x text-primary"></i>
                    <h4 className="mt-3">Global Reach</h4>
                    <p>Covering breaking news from all corners of the world.</p>
                </div>
            </div>
        </div>
        </Layout>
        </div>
    );
};

export default AboutUs;
